define('lib/Podio.UI.DelayedContent',['require','underscore','jquery','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.Event','lib/Podio.Utils'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var podioEvent = require('lib/Podio.Event');
  var utils = require('lib/Podio.Utils');

  function onInit() {
    var elmDelayedContainers = $('.delayed-content');

    var requests = _.map(elmDelayedContainers, function(container) {
      var elmContainer = $(container);
      var url = elmContainer.data('url');

      elmContainer.addClass('hidden');

      var request = transport.getJSON(url, {});
      request.done(function(responseData) {

        if (!responseData.data ) {
          // No data
          return;
        }

        elmContainer.html(responseData.data.html);

        elmContainer.fadeIn('slow', function() {
          elmContainer.css('display', '');
          elmContainer.removeClass('hidden');
        });

        utils.markUserTime('delayed-content-done', false);
      });

      return request;
    });

    if (!_.isEmpty(requests)) {
      $.when.apply(this, requests).then(function() {
        podioEvent.trigger(podioEvent.Types.delayedContentReady);
      });
    }
  }

  podioEvent.bind(podioEvent.Types.init, onInit);

});

